var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeesAddedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "employees-added-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#7aba56",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(25.667 26.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M33.6,10.618H29.954l-2.127-5.4A4.03,4.03,0,0,0,24.1,2.688H15.9a4.027,4.027,0,0,0-3.725,2.533l-2.129,5.4H6.4a4.4,4.4,0,0,0-4.4,4.4v17.5a4.4,4.4,0,0,0,4.4,4.4H33.6a4.4,4.4,0,0,0,4.4-4.4v-17.5a4.4,4.4,0,0,0-4.4-4.4ZM27.461,25.956a.739.739,0,0,1-.739.739H22.928v3.794a.739.739,0,0,1-.739.739H17.812a.739.739,0,0,1-.739-.739V26.695H13.278a.739.739,0,0,1-.739-.739V21.579a.739.739,0,0,1,.739-.739h3.794V17.046a.739.739,0,0,1,.739-.739h4.377a.739.739,0,0,1,.739.739V20.84h3.794a.739.739,0,0,1,.739.739ZM12.533,10.618l1.794-4.55A1.7,1.7,0,0,1,15.9,5h8.2a1.7,1.7,0,0,1,1.572,1.067l1.794,4.549Z",
    transform: "translate(-2 -2.688)",
    fill: "#7aba56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesAddedIcon);
export default __webpack_public_path__ + "static/media/employees-added-icon.f8a20acb52b3dfc603577babc56b2b43.svg";
export { ForwardRef as ReactComponent };